import { PriceStrategyUIConfigEntry } from '../types';
import { targetGrossMarginUIConfig } from './target-gross-margin';

export const rafTargetGrossMarginUIConfig: PriceStrategyUIConfigEntry =
  targetGrossMarginUIConfig;
